module.exports = __webpack_public_path__ + "static/media/banner-subtitle-vertical.0746145b.svg";